import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAllowedReports from '../../hooks/useAllowedReports';

/**
 * Blocks direct navigation to a report route when the profile lacks the OperationMst grant.
 */
const ReportOperationRoute = ({ operationPath, children }) => {
  const location = useLocation();
  const path = operationPath || location.pathname;
  const { loading, isPathAllowed } = useAllowedReports();

  if (loading) {
    return (
      <div className="reports-home" style={{ padding: '24px' }}>
        Loading report…
      </div>
    );
  }

  if (!isPathAllowed(path)) {
    return <Navigate to="/reports" replace />;
  }

  return children;
};

export default ReportOperationRoute;
